/**
 * Function used to calculate message to send to Heap Analytics
 * @param {object} data dictionary containing information about the decision
 * @returns {string}
 */
const determineApplicationStatus = (data) => {
  if (data.pending) {
    return 'pending'
  }
  if (data.approved) {
    return 'approved'
  }
  if (data.approved === false && !data.pending) {
    return 'rejected'
  }
  if (data.error_message) {
    return `error in applicaton status ${data.error_message}`
  }
}

export default determineApplicationStatus;